import { useContext, useEffect } from 'react';
import { CoreContext } from '../context/index.js';
import { selectCaptcha } from '../storeSelectors/captcha.js';

const useCaptcha = () => {
    const { thunks: { captcha: { getCaptcha }, }, useDispatch, useSelector, } = useContext(CoreContext);
    const dispatch = useDispatch();
    const captchaData = useSelector(selectCaptcha);
    const { isFulfilled } = captchaData;
    const handleGetCaptcha = async () => {
        dispatch(getCaptcha());
    };
    useEffect(() => {
        if (isFulfilled)
            return;
        handleGetCaptcha();
    }, []);
    return captchaData;
};

export { useCaptcha as default };
//# sourceMappingURL=useCaptcha.js.map
